import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";


const PrintOrderDetailsDialog = ({
  open,
  onClose
}) => {


  return (

    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >

      <DialogTitle>

        Print Order Details


        <IconButton
          onClick={onClose}
          sx={{
            position:"absolute",
            right:8,
            top:8
          }}
        >

          <CloseIcon />

        </IconButton>


      </DialogTitle>


      <DialogContent>

        <Typography>
          Print preview will be implemented here.
        </Typography>

      </DialogContent>


    </Dialog>

  );

};


export default PrintOrderDetailsDialog;